import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import LoginPopup from '../auth/loginpopup';
import Login from '../auth/login';
import { logouthandler } from '../api/authSlice';
import { MdShoppingCart } from 'react-icons/md';
import { Badge, Button } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { cartCouponSelector } from '../api/cartSlice';
import CartView from '../components/social_coupons/cartView';
import { Link, useLocation } from 'react-router-dom';
import { viewCartshowModal } from '../api/modalSlice';
import { UserOutlined, LogoutOutlined } from '@ant-design/icons';
import Dropdown from '../shared/dropdown';

export default function Topbar({ isAuthenticate, user, balance }) {
    const dispatch = useDispatch();
    const { pathname } = useLocation();
    const items = useSelector(cartCouponSelector);

    console.log(user);

    useEffect(() => {
        if (pathname === "/checkout") {
            return dispatch(viewCartshowModal(false));
        }
    }, [pathname, dispatch]);

    return (
        <div className="bg-[#88448a] flex justify-end items-end pt-2 text-white text-right" style={{ fontFamily: 'Poppins' }}>
            <ul className="flex text-center items-center md:mr-10 mr-2 md:space-x-10 space-x-5">
                {isAuthenticate && (
                    <li>
                        <small style={{ fontSize: "16px", textTransform: 'capitalize' }} className="text-white hidden md:block">
                            Welcome, {user.user_name}
                        </small>
                    </li>
                )}
                {user && (
                    <li>
                        <small style={{ fontSize: "16px" }} className="text-white hidden md:block">
                            Balance: &#8377; {balance}
                        </small>
                    </li>
                )}
                <li>
                    <Link to="/cart">
                        <Badge size="small" href="/cart" count={items.cartCoupons.length}>
                            <MdShoppingCart className="text-white mt-1 text-xl text-[26px]" />
                        </Badge>
                    </Link>
                </li>
                {!isAuthenticate && (
                    <li className="text-">
                        <LoginPopup>
                            <Login />
                        </LoginPopup>
                    </li>
                )}
                {!isAuthenticate && (
                    <li>
                        <Button type="link" className="" style={{ color: "white", fontSize: "16px", paddingLeft: "2px" }} href="/user-register">
                            Register
                        </Button>
                    </li>
                )}
                {isAuthenticate && (
                    <Dropdown
                        username="user"
                        userIcon={<LogoutOutlined style={{ fontSize: "1.2rem", transform: "translateY(-3px)", fontWeight: "bold" }} />}
                        icon={<UserOutlined style={{ fontSize: "1.2rem", transform: "translateY(-3px)", fontWeight: "bold" }} />}
                    />
                )}
            </ul>
            {/* <CartView /> */}
        </div>
    );
}

const TopbarWrap = styled.div`
    background-color: #88448a;
    color: white;

    .tcart {
        font-size: 1.48rem;
        cursor: pointer;
        transform: translateY(1px);
    }
    .container {
        width: 90%;
        margin: 0 auto;

        ul {
            margin: 0;
            display: flex;
            padding: 0 0.1rem;
            align-items: center;
            justify-content: flex-end;

            li {
                list-style: none;
                font-size: 1.2rem;
                margin: 0 1.3rem;
            }
        }
    }
`;
